import dynamic from 'next/dynamic';

import { ChevronRight } from '@src/components/atoms/icons/chevron-right';
import { TripDateSpan } from '@src/components/common/formatting/trip-date-span';
import { useTripListItem } from '@src/contexts/trip-list-item-context';
import { useIsMobile } from '@src/hooks/use-is-mobile';

import { DatesArrowRight } from '../../trip-detail-header/styles';
import { GuestName, OngoingTripTitle } from '../styles';
import { Card } from './card';
import { FormattedDate } from './formatted-date';
import { MobileOnGoingFutureTripCard } from './mobile-ongoing-future-trip-card';
import { ChevronWrapper, DesktopDates, MobileDates, OngoingFutureTripCardWrapper, SpacedContent } from './styles';

const CheckinAccessAndStatus = dynamic(
  () =>
    import('@src/components/organisms/trip-preview-card/checkin-access-and-status').then(
      (mod) => mod.CheckinAccessAndStatus,
    ),
  { ssr: false },
);

export const OnGoingFutureTripCard = () => {
  const { trip } = useTripListItem();
  const { primaryGuest } = trip;
  const isMobile = useIsMobile();
  const mainGuestName =
    primaryGuest.firstName && primaryGuest.lastName ? `${primaryGuest.firstName} ${primaryGuest.lastName}` : '';
  const image = trip.unitGroup.pictures[0]?.responsiveImage;
  const badge = <Card.Badge tripStatus={trip.status} arrivalDate={trip.arrival} timeZone={trip.property.timezone} />;

  return (
    <OngoingFutureTripCardWrapper data-testid="trip-preview-card">
      {isMobile ? (
        <MobileOnGoingFutureTripCard />
      ) : (
        <Card href={`/trips/${trip.id}`}>
          <Card.Image {...image} alt={image?.alt ?? undefined} title={image?.title ?? undefined}>
            {badge}
          </Card.Image>

          <Card.Content>
            <SpacedContent>
              <OngoingTripTitle>{trip.property.name}</OngoingTripTitle>

              <MobileDates>
                <FormattedDate date={trip.arrival} timeZone={trip.property.timezone} />
                <DatesArrowRight />
                <FormattedDate date={trip.departure} timeZone={trip.property.timezone} />
              </MobileDates>
              <DesktopDates>
                <TripDateSpan trip={trip} format="short" />
              </DesktopDates>
              {mainGuestName && <GuestName>{mainGuestName}</GuestName>}
            </SpacedContent>
          </Card.Content>

          <ChevronWrapper>
            <ChevronRight />
          </ChevronWrapper>
        </Card>
      )}
      <CheckinAccessAndStatus />
    </OngoingFutureTripCardWrapper>
  );
};
